import FullScreenCard from '../shared/FullScreenCard';
import Table from '../shared/Table';
import { fetchGet } from '../../utils/fetch';
import { useEffect, useState } from 'react';
import { transformDate } from '../../utils/date';

function Points() {

  const [headers, setHeaders] = useState([
    {id: 'header0', text: 'Alerta'}
  ]);

  const [historyList, setHistoryList] = useState([
    {id: '1a', fields: [
        {id: '0', text: 'Error conectándose al servidor'}
      ]
    }
  ]);

  const prepareHistoryList = (list) => {
    setHeaders([
      {id: 'header0', text: 'Cambio'},
      {id: 'header1', text: 'Fecha'},
      {id: 'header2', text: 'Responsable'},
      {id: 'header3', text: 'Tipo'},
      {id: 'header4', text: 'Razón'}
    ]);
    const newList = [];
    for (let i = 0; i < list.length; i++) {
      let changeType;
      let changeAmount;
      if (list[i].type === 'approve') {
        changeType = 'Aprobación de solicitud';
        changeAmount = list[i].change;
      };
      if (list[i].type === 'adjust') {
        changeType = 'Ajuste de puntos';
        list[i].change > 0 ? changeAmount = '+' + list[i].change : changeAmount = list[i].change;
      };
      if (list[i].type === 'reset') {
        changeType = 'Restablecimiento general';
        changeAmount = list[i].change;
      };
      const item = {
        id: i,
        fields: [
          {id: '0', text: changeAmount},
          {id: '1', text: transformDate(list[i].date)},
          {id: '2', text: list[i].change_author},
          {id: '3', text: changeType},
          {id: '4', text: list[i].reason}
        ]
      }
      newList.push(item);
    }
    setHistoryList(newList);
  }

  useEffect(() => {
    const getUsersList = async () => {
      const response = await fetchGet('points/');
      if (response.success) {
        prepareHistoryList(response.list);
      } else {
        if (response.reason === 'No hay elementos en el historial del usuario') {
          setHeaders(
            [{id: 'header0', text: 'Aviso'}]
          );
          setHistoryList(
            [{id: '1a', fields: [
                {id: '0', text: 'Aún no hay cambios de puntos registrados'}
              ]
            }]
          );
        }
      }
    }
    getUsersList();
  }, []);

  return (
    <FullScreenCard>
      <h2>Historial de Cambios de Puntos del Usuario</h2>
      <Table
            headers={headers}
            data={historyList}
            type='display'
            headerClass="tableHeadUser"
            rowClass="tableRowUser"
        />
    </FullScreenCard>
  )
}

export default Points